module.exports = __webpack_public_path__ + "1.5.0-unryo/img/step4.47ea8c0f.png";